import React from 'react'
import styled, { css } from 'styled-components'

const checkbox = css`
  position: absolute; // take it out of document flow
  opacity: 0; // hide it
  z-index: 1; // add it on top to make clickable
  & + label {
    position: relative;
    cursor: pointer;
    padding: 0;
    font-size: 15px;
    display: flex;
  }
  // Box.
  & + label:before {
    content: '';
    display: inline-block;
    vertical-align: text-top;
    width: 21px;
    height: 21px;
    min-width: 21px;
    border: 1px solid var(--border);
    background: #fff;
    margin-right: 10px;
  }

  &:hover {
    cursor: pointer;

    & + label:before {
      background: #fff;
      border-color: var(--primary);
    }
  }

  &:disabled + label {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:disabled + label:before {
    background: #bfbfbf;
    border-color: #bfbfbf;
  }
`
const CheckboxField = styled.input.attrs({ type: 'checkbox' })`
  ${checkbox}

  & + label:before {
    border-radius: 2px;
  }

  & + label:after {
    content: '';
    position: absolute;
    display: inline-block;
    height: 12px;
    width: 6px;
    left: 8px;
    top: 9px;
    transform: translate(0, -50%) rotate(45deg);
  }

  &:checked + label:after {
    border-bottom: 2px solid var(--primary);
    border-right: 2px solid var(--primary);
  }

  &:disabled + label:after {
    border: 0;
  }
`

export const Checkbox = ({ label, ...rest }) => (
  <div>
    <CheckboxField {...rest} />
    <label htmlFor={rest.id}>{label}</label>
  </div>
)

export const RadioField = styled.input.attrs({ type: 'radio' })`
  ${checkbox}
  & + label:before {
    background: #fff;
    border-radius: 50%;
  }

  & + label:after {
    content: '';
    position: absolute;
    display: inline-block;
    height: 10px;
    width: 10px;
    left: 6px;
    border-radius: 50%;
    background: #fff;
    top: 11px;
    transform: translate(0, -50%);
  }

  &:disabled + label:after {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:checked + label:after {
    background: var(--primary);
  }
`
export const Radio = ({ label, ...rest }) => (
  <div>
    <RadioField {...rest} />
    <label htmlFor={rest.id}>{label}</label>
  </div>
)
